import React from 'react'
import styled from 'styled-components'
import { Car } from '../../../../types'
import { formatDateString } from '../../../../utils/dateHelper'
import { addMonths } from 'date-fns'
import { TranslatedText } from '@staccx/i18n'
import { Emphasize } from '../../components/V3/_shared/Emphasize'

const ServiceCardNew: React.FC<{
  car: Car
  setShowServiceCard: any
  showServiceCard: any
}> = ({ car, setShowServiceCard, showServiceCard }) => {
  return (
    <>
      <div className="flex flex-col gap-4 w-full">
        <div className="flex flex-row gap-2 justify-start">
          <button
            onClick={() => setShowServiceCard(true)}
            className="w-fit px-2 flex items-start justify-start text-start relative hover:scale-105 transition-all ease-in-out cursor-pointer"
          >
            <img
              src="/service-card.svg"
              alt="service card image"
              className="w-[200px]"
            />
          </button>
          <div className="flex flex-col gap-2">
            <div>
              <Emphasize>Servicekortnummer</Emphasize>
              <p>{car.budgetNo}</p>
            </div>
            <div>
              <Emphasize>Utløpsdato</Emphasize>
              <p>
                {car.plannedReturnDate
                  ? formatDateString(
                      addMonths(new Date(car.plannedReturnDate), 1),
                    )
                  : 'Ukjent'}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ServiceCardNew

const Wrapper = styled.div`
  font-size: var(--font-text);
  width: 100%;
`

const HeadingText = styled.div`
  font-size: var(--font-base);
  color: var(--color-primary);
`

const BoldText = styled.div`
  font-weight: var(--fontWeight-bold);
`

const ServiceCardWrapper = styled.div`
  width: 140px;
`
